import { fromUrl, NO_HOSTNAME } from 'parse-domain';

export function buildURL(url: string, queryParamMap: Record<string, string>) {
  const urlToReturn = new URL(url);
  urlToReturn.search = new URLSearchParams(queryParamMap).toString();
  return urlToReturn.toString();
}

export function checkValidUrl(newValue: string) {
  const trimmedValue = newValue.trim();

  return (
    trimmedValue.startsWith('http://') || trimmedValue.startsWith('https://')
  );
}

/**
 * Retrieves the image source for the specified website's favicon.
 *
 *
 * @param url Web URL
 * @returns {string}
 */
export function getFaviconSource(url: string) {
  let domain = fromUrl(url);

  if (domain === NO_HOSTNAME) {
    domain = encodeURIComponent(url);
  }

  return `http://www.google.com/s2/favicons?domain=${domain}&sz=32`;
}
